import { CommentModel } from "@/types";

// 関数にプロパティを追加するための型定義
declare global {
  interface Function {
    _lastResult?: string;
    _lastCount?: number;
  }
}

/**
 * プレーヤーの現在時刻に基づいてコメントをフィルタリングする
 * @param allComments 全コメントデータ
 * @param startAt 配信開始時刻（ISO 8601形式）
 * @param currentTime プレーヤーの現在時刻（秒）
 * @returns フィルタリング後のコメント配列
 */
export const filterCommentsByTime = (
  allComments: CommentModel[],
  startAt: string,
  currentTime: number
): CommentModel[] => {
  if (!startAt || !allComments.length) {
    return [];
  }

  try {
    const startTime = new Date(startAt).getTime();
    const currentPlayTime = startTime + (currentTime * 1000);
    
    const filtered = allComments.filter(comment => {
      try {
        const commentTime = new Date(comment.createdAt).getTime();
        return commentTime <= currentPlayTime;
      } catch (error) {
        // 不正な日時形式のコメントは除外
        console.warn('Invalid comment createdAt format:', comment.createdAt, error);
        return false;
      }
    });

    // デバッグログ（開発時のみ、フィルタ結果が変化した時のみ）
    if (process.env.NODE_ENV as string === 'development') {
      const filteredIds = filtered.map(c => c.id).join(',');
      
      // 前回の結果と比較して変化があった場合のみログ出力
      if (!filterCommentsByTime._lastResult || filterCommentsByTime._lastResult !== filteredIds) {
        filterCommentsByTime._lastResult = filteredIds;
        filterCommentsByTime._lastCount = filtered.length;
      }
    }
    
    return filtered;
  } catch (error) {
    // 不正なstartAt形式の場合は空配列を返す
    console.warn('Invalid startAt format:', startAt, error);
    return [];
  }
};

/**
 * 単一のコメントが表示されるべきかどうかを判定する
 * @param comment コメントデータ
 * @param startAt 配信開始時刻（ISO 8601形式）
 * @param currentTime プレーヤーの現在時刻（秒）
 * @returns 表示すべき場合はtrue
 */
export const shouldShowComment = (
  comment: CommentModel, 
  startAt: string, 
  currentTime: number
): boolean => {
  if (!startAt) {
    return false;
  }

  try {
    const startTime = new Date(startAt).getTime();
    const currentPlayTime = startTime + (currentTime * 1000);
    const commentTime = new Date(comment.createdAt).getTime();
    
    return commentTime <= currentPlayTime;
  } catch (error) {
    // エラーの場合は表示しない
    console.warn('Error in shouldShowComment:', error);
    return false;
  }
};
